import React from "react";
import ReactGA from "react-ga4";

type Props = {
  label: string;
  min?: number;
  max?: number;
  value?: number;
  setValue?: (newValue: number) => void;
  error?: string;
};

const ParameterInput = ({
  label,
  min = 0,
  max = 100,
  value = 0,
  setValue,
  error,
}: Props) => {
  return (
    <div className="textBox cell">
      <input
        className="text"
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={(event) => {
          setValue?.(parseInt(event.target.value, 10));
          ReactGA.event({
            category: "controller",
            action: "parameter change",
            label,
          });
        }}
      />
      <label className="label">
        {label} <span id="value">{value}</span>
      </label>
      <label className="error">{error}</label>
    </div>
  );
};

export default ParameterInput;
